export default __webpack_public_path__ + "11b138e3197d13f5c79e2cdef9628d1c.glb";